import styled from 'styled-components'
import { smStyle } from '@/components/Adapter'

export const PriceAnnItemStyled = styled.a`
  width: 100%;
  font-size: 12px;
  ${smStyle} {
    margin-top: 80px;
    font-size: 14px;
  }
`
